/**
 * @generated SignedSource<<8f250e65008557a3351cdeedc77ea1a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksSubSectionWidgetAndAdsQuery$data = {
  readonly parentSection: {
    readonly entityId: string;
  };
  readonly subSection: {
    readonly advertZone: string | null | undefined;
    readonly entityId: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"commentQueueQuery" | "discoveryWidgetPostMagazineQueueQuery" | "focusArticleHomeFocusArticleQuery" | "hundredTopTablesDiscoveryWidgetQuery" | "multimediaQuery" | "openQuestionsSeriesDiscoveryWidgetQuery">;
  readonly " $fragmentType": "hooksSubSectionWidgetAndAdsQuery";
};
export type hooksSubSectionWidgetAndAdsQuery$key = {
  readonly " $data"?: hooksSubSectionWidgetAndAdsQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksSubSectionWidgetAndAdsQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksSubSectionWidgetAndAdsQuery"
};

(node as any).hash = "6768480bc2a81be6dec22450392c0496";

export default node;
